import { render, staticRenderFns } from "./github.button.vue?vue&type=template&id=a3ce36e0&"
import script from "./github.button.vue?vue&type=script&lang=ts&"
export * from "./github.button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports